<template>
  <div>
    <h1>环境报表</h1>
  </div>
</template>
<script>
export default {
  name: 'ChartsEnvironment',
  data() {
    return {}
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
}
</script>


// WEBPACK FOOTER //
// src/components/report/Environment.vue